export {
  decideGraphicsTier,
  getGraphicsTier,
  type GraphicsTier,
  type GraphicsTierDevice,
} from "#graphics-tier";
